export const STEAM_PRIVACY_SETTINGS_URL =
  "https://steamcommunity.com/my/edit/settings";

export const LOW_CS2_HOURS_THRESHOLD = 200;
export const MIN_STEAM_ACCOUNT_AGE_MONTHS = 6;

export const STEAM_SIGNUP_WARNING_CODES = {
  LOW_CS2_HOURS: "low_cs2_hours",
  YOUNG_STEAM_ACCOUNT: "young_steam_account",
  PROFILE_NOT_PUBLIC: "profile_not_public",
  GAME_DATA_NOT_ACCESSIBLE: "game_data_not_accessible",
};

const UNLIKELY_TITLE = "This application is highly unlikely to be accepted";

const UNLIKELY_CLOSING =
  "Ouro does not accept alt accounts or throwaway Steam accounts. You can continue, but please keep in mind that this application is highly unlikely to be accepted.";

export const STEAM_PRIVACY_INCOGNITO_STEPS = [
  "Set your Steam profile to Public.",
  "Set Game details to Public.",
  'Uncheck "Always keep my total playtime private".',
  "Open your Steam profile in an incognito or private browser window and confirm CS2 is in your games list with hours visible.",
];

export function parseSteamSignupReasons(rawReasons) {
  return String(rawReasons || "")
    .split(",")
    .map((reason) => reason.trim())
    .filter(Boolean);
}

export function getUnlikelyAcceptanceCopy(reasons = []) {
  const hasLowHours = reasons.includes(STEAM_SIGNUP_WARNING_CODES.LOW_CS2_HOURS);
  const hasYoungAccount = reasons.includes(
    STEAM_SIGNUP_WARNING_CODES.YOUNG_STEAM_ACCOUNT
  );

  if (hasLowHours && hasYoungAccount) {
    return {
      title: UNLIKELY_TITLE,
      body: `This Steam account is less than ${MIN_STEAM_ACCOUNT_AGE_MONTHS} months old and shows under ${LOW_CS2_HOURS_THRESHOLD} hours of CS2. ${UNLIKELY_CLOSING}`,
    };
  }
  if (hasYoungAccount) {
    return {
      title: UNLIKELY_TITLE,
      body: `This Steam account is less than ${MIN_STEAM_ACCOUNT_AGE_MONTHS} months old. ${UNLIKELY_CLOSING}`,
    };
  }
  if (hasLowHours) {
    return {
      title: UNLIKELY_TITLE,
      body: `This Steam account shows under ${LOW_CS2_HOURS_THRESHOLD} hours of CS2. ${UNLIKELY_CLOSING}`,
    };
  }
  return {
    title: UNLIKELY_TITLE,
    body: UNLIKELY_CLOSING,
  };
}

export function hasHiddenSteamGameDetails(warnings = []) {
  return warnings.some(
    (warning) =>
      warning === STEAM_SIGNUP_WARNING_CODES.PROFILE_NOT_PUBLIC ||
      warning === STEAM_SIGNUP_WARNING_CODES.GAME_DATA_NOT_ACCESSIBLE
  );
}

export function hasUnlikelySteamSignupWarnings(warnings = []) {
  return warnings.some(
    (warning) =>
      warning === STEAM_SIGNUP_WARNING_CODES.LOW_CS2_HOURS ||
      warning === STEAM_SIGNUP_WARNING_CODES.YOUNG_STEAM_ACCOUNT
  );
}
